import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import { palette } from '@livable/saas-react-components';
const useUpdateUtilityCredentialsBatchModalStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  modalContent: {
    maxHeight: '650px',
    overflow: 'scroll'
  },
  itemGeneralSpacing: {
    marginBottom: '10px'
  },
  credentialFormContainer: {
    padding: '16px 40px 32px'
  },
  credentialFormHeader: {
    marginBottom: '24px'
  },
  credentialsWarning: {
    width: '100%',
    marginBottom: '24px',
    justifyContent: 'flex-start'
  },
  pairValueContainer: {
    width: '100%'
  },
  credentialsInput: {
    width: '49%',
    '&:first-child': {
      marginRight: '2%'
    }
  },
  securityQuestionsInput: {
    width: '49%',
    '&:first-child': {
      marginRight: '2%'
    }
  },
  securityQuestionsInputAnswer: {
    width: 'calc(49% - 60px)'
  },
  securityQuestionsDeleteBtn: {
    marginLeft: '10px'
  },
  modalFooter: {
    padding: '32px 40px',
    borderTop: "1px solid ".concat(palette.shades[400])
  },
  footerEven: {
    display: 'flex',
    justifyContent: 'space-between',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse'
    }
  },
  footerButton: {
    display: 'inline-block',
    '& + &': {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('sm')]: {
      width: '100%',
      '& + &': {
        marginTop: '10px',
        marginLeft: '0'
      },
      '& button': {
        width: '100%'
      }
    }
  },
  footerWrapper: {
    display: 'flex',
    [breakpointsFunc.breakpoints.down('sm')]: {
      flexDirection: 'column',
      '& + &': {
        marginBottom: '10px'
      }
    }
  },
  rightButton: {
    '& + &': {
      marginLeft: '10px'
    }
  }
}));
export default useUpdateUtilityCredentialsBatchModalStyles;